import { useCallback, useEffect, useRef, useState } from 'react';
import { authHeader } from '../../utils/helpers';
import { submitAnswer } from '../../actions/data';

const IFRAME_WRAPPER_ID = 'medicosearchWidget';
const MEDICOSEARCH_SCRIPT_SRC = process.env.REACT_APP_MEDICOSEARCH_SCRIPT_SRC;
const MEDICOSEARCH_TOKEN = process.env.REACT_APP_MEDICOSEARCH_TOKEN;

export const useFertilityIframe = ({
  configId,
  language,
  testCode,
  conversationFlowStateKey,
  conversationId,
  userId,
  dispatch
}) => {
  const [iframeLoading, setIframeLoading] = useState(true);
  const [scriptError, setScriptError] = useState(false);
  const containerRef = useRef(null);

  const initWidget = useCallback(() => {
    if (window.MedicosearchBookingWidget2) {
      new window.MedicosearchBookingWidget2({
        wrapper: `#${IFRAME_WRAPPER_ID}`,
        token: MEDICOSEARCH_TOKEN,
        configId,
        lang: language,
        // TODO: Refactor this to use api/index.js and handle error properly
        onBookingDone: function (bookingData) {
          const booking = bookingData.bookings[0];
          const bookingId = booking.id;
          const startDate = booking.startDate;

          fetch(`${process.env.REACT_APP_API_URL}/test-results/${testCode}/consultation-booking`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              ...authHeader()
            },
            body: JSON.stringify({
              consultationBookingId: bookingId,
              bookedConsultationDate: startDate
            })
          })
          .then(() => {
            dispatch(
              submitAnswer({
                action: 'next',
                conversationFlowStateKey,
                conversationId,
                userId
              })
            );
          })
          .catch(error => {
            console.error('Error sending booking data:', error);
          });
        }
      });

      setIframeLoading(false);
    }
  }, [configId, language, testCode, conversationFlowStateKey, conversationId, userId, dispatch]);

  useEffect(() => {
    setIframeLoading(true);
    setScriptError(false);
    if (!configId || !userId) return;

    const script = document.querySelector(`script[src^="${MEDICOSEARCH_SCRIPT_SRC}"]`) ||
      (() => {
        const s = document.createElement('script');
        s.src = MEDICOSEARCH_SCRIPT_SRC;
        s.async = true;
        s.onload = () => initWidget();
        s.onerror = () => {
          setIframeLoading(false);
          setScriptError(true);
        };
        document.body.appendChild(s);
        return s;
      })();

    if (script && script.onload === null) {
      initWidget();
    }

    return () => {
      const widgetContainer = document.getElementById(IFRAME_WRAPPER_ID);
      if (widgetContainer) {
        widgetContainer.innerHTML = '';
      }
    };
  }, [configId, userId, initWidget]);

  return {
    containerRef,
    iframeLoading,
    scriptError,
    IFRAME_WRAPPER_ID
  };
};
